
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftBottom25 as ObiThreewayAcuatorPistonInleftBottom25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-bottom-25.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftBottom25 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-bottom-25',
   elementClass: ObiThreewayAcuatorPistonInleftBottom25Element,
   events: {
     
   }
  });
 
 